import {PropsWithChildren, useContext} from "react";
import {css, SerializedStyles, Theme, useTheme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {color, p} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons";
import {ICoreModalProps, ModalCore} from "@pg-design/modal";
import {Text} from "@pg-design/text";

import {DrawerContext, DrawerContextProvider, IDrawerTheme, IDrawerVariant} from "./DrawerContext";

interface IDrawerProps extends Omit<ICoreModalProps, "contentStyle" | "onModalClose"> {
    variant?: IDrawerVariant;
    systemTheme?: IDrawerTheme;
    zIndex?: number;
    onDrawerClose: ICoreModalProps["onModalClose"];
    contentStyle?: SerializedStyles;
}

export const Drawer = (props: PropsWithChildren<IDrawerProps>) => {
    const {children, systemTheme, contentStyle, zIndex = 9000, ...restProps} = props;
    const theme = useTheme();

    const isDarkTheme = systemTheme === "dark";
    const variant = props.variant ? props.variant : "right";

    const contentStyleProp = [contentBaseStyle({isDarkTheme, theme, variant})];
    if (contentStyle) {
        contentStyleProp.push(contentStyle);
    }

    return (
        <DrawerContextProvider value={{variant, systemTheme: systemTheme ? systemTheme : "light"}}>
            <ModalCore
                closeButton={(closeDrawer) => (
                    <div onClick={closeDrawer} css={closeButtonStyle}>
                        <CloseIcon fill={isDarkTheme ? "#fff" : theme.colors.secondary} css={closeButtonIconStyle} />
                    </div>
                )}
                contentStyle={contentStyleProp}
                overlayStyle={[overlayBaseStyle(zIndex)]}
                onModalClose={props.onDrawerClose}
                {...restProps}
            >
                {children}
            </ModalCore>
        </DrawerContextProvider>
    );
};

Drawer.Header = (props: PropsWithChildren<{}>) => {
    const {children} = props;
    const {systemTheme} = useContext(DrawerContext);
    const theme = useTheme();

    return (
        <div>
            <Text as="h3" variant="headline_4" css={[systemTheme === "dark" ? "#fff" : theme.colors.secondary, p(3, 2)]}>
                {children}
            </Text>
        </div>
    );
};

Drawer.Content = (
    props: PropsWithChildren<{
        className?: string;
    }>
) => {
    const {children, className} = props;
    const {systemTheme} = useContext(DrawerContext);
    const theme = useTheme();

    return (
        <Text as="div" variant="body_copy_2" css={[color(systemTheme === "dark" ? "#fff" : theme.colors.secondary), p(0, 2, 2)]} className={className}>
            {children}
        </Text>
    );
};

// Styles
const overlayBaseStyle = (zIndex: number) => css`
    z-index: ${zIndex};
    display: flex;
    justify-content: center;
    align-items: center;
`;

interface IContentBaseStyleProps {
    isDarkTheme: boolean;
    theme: Theme;
    variant: IDrawerVariant;
}
const contentBaseStyle = ({isDarkTheme, theme, variant}: IContentBaseStyleProps) => css`
    top: 0;
    bottom: 0;
    width: 90%;
    max-width: 50rem;
    border-radius: 0;
    background-color: ${isDarkTheme ? theme.colors.secondary : "#fff"};
    padding: 0;
    border: 0;
    ${elevation(1)};
    display: flex;
    flex-direction: column;

    ${variant === "right"
        ? css`
              right: 0;

              &.ReactModal__Content {
                  transform: translate(100%, 0);
              }
          `
        : css`
              left: 0;

              &.ReactModal__Content {
                  transform: translate(-100%, 0);
              }
          `};

    &.ReactModal__Content--after-open {
        transform: translate(0, 0);
    }
`;

const closeButtonStyle = css`
    position: absolute;
    ${p(3)};
    right: 0;
    cursor: pointer;
`;

const closeButtonIconStyle = css`
    width: 2.4rem;
    height: 2.4rem;
`;
import {PropsWithChildren, useContext} from "react";
import {css, SerializedStyles, Theme, useTheme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {color, p} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons";
import {ICoreModalProps, ModalCore} from "@pg-design/modal";
import {Text} from "@pg-design/text";

import {DrawerContext, DrawerContextProvider, IDrawerTheme, IDrawerVariant} from "./DrawerContext";

interface IDrawerProps extends Omit<ICoreModalProps, "contentStyle" | "onModalClose"> {
    variant?: IDrawerVariant;
    systemTheme?: IDrawerTheme;
    zIndex?: number;
    onDrawerClose: ICoreModalProps["onModalClose"];
    contentStyle?: SerializedStyles;
}

export const Drawer = (props: PropsWithChildren<IDrawerProps>) => {
    const {children, systemTheme, contentStyle, zIndex = 9000, ...restProps} = props;
    const theme = useTheme();

    const isDarkTheme = systemTheme === "dark";
    const variant = props.variant ? props.variant : "right";

    const contentStyleProp = [contentBaseStyle({isDarkTheme, theme, variant})];
    if (contentStyle) {
        contentStyleProp.push(contentStyle);
    }

    return (
        <DrawerContextProvider value={{variant, systemTheme: systemTheme ? systemTheme : "light"}}>
            <ModalCore
                closeButton={(closeDrawer) => (
                    <div onClick={closeDrawer} css={closeButtonStyle}>
                        <CloseIcon fill={isDarkTheme ? "#fff" : theme.colors.secondary} css={closeButtonIconStyle} />
                    </div>
                )}
                contentStyle={contentStyleProp}
                overlayStyle={[overlayBaseStyle(zIndex)]}
                onModalClose={props.onDrawerClose}
                {...restProps}
            >
                {children}
            </ModalCore>
        </DrawerContextProvider>
    );
};

Drawer.Header = (props: PropsWithChildren<{}>) => {
    const {children} = props;
    const {systemTheme} = useContext(DrawerContext);
    const theme = useTheme();

    return (
        <div>
            <Text as="h3" variant="headline_4" css={[systemTheme === "dark" ? "#fff" : theme.colors.secondary, p(3, 2)]}>
                {children}
            </Text>
        </div>
    );
};

Drawer.Content = (
    props: PropsWithChildren<{
        className?: string;
    }>
) => {
    const {children, className} = props;
    const {systemTheme} = useContext(DrawerContext);
    const theme = useTheme();

    return (
        <Text as="div" variant="body_copy_2" css={[color(systemTheme === "dark" ? "#fff" : theme.colors.secondary), p(0, 2, 2)]} className={className}>
            {children}
        </Text>
    );
};

// Styles
const overlayBaseStyle = (zIndex: number) => css`
    z-index: ${zIndex};
    display: flex;
    justify-content: center;
    align-items: center;
`;

interface IContentBaseStyleProps {
    isDarkTheme: boolean;
    theme: Theme;
    variant: IDrawerVariant;
}
const contentBaseStyle = ({isDarkTheme, theme, variant}: IContentBaseStyleProps) => css`
    top: 0;
    bottom: 0;
    width: 90%;
    max-width: 50rem;
    border-radius: 0;
    background-color: ${isDarkTheme ? theme.colors.secondary : "#fff"};
    padding: 0;
    border: 0;
    ${elevation(1)};
    display: flex;
    flex-direction: column;

    ${variant === "right"
        ? css`
              right: 0;

              &.ReactModal__Content {
                  transform: translate(100%, 0);
              }
          `
        : css`
              left: 0;

              &.ReactModal__Content {
                  transform: translate(-100%, 0);
              }
          `};

    &.ReactModal__Content--after-open {
        transform: translate(0, 0);
    }
`;

const closeButtonStyle = css`
    position: absolute;
    ${p(3)};
    right: 0;
    cursor: pointer;
`;

const closeButtonIconStyle = css`
    width: 2.4rem;
    height: 2.4rem;
`;
